import { useState } from 'react';

function useFormState<T>(initialState: T) {
  const [formData, setFormData] = useState<T>(initialState);

  const setFormFieldData = <K extends keyof T>(field: K, value: T[K]) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  return { formData, setFormFieldData, setFormData };
}

export default useFormState;
